import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ComplexPolymerComponentsTableTab from './ComplexPolymerComponentsTableTab';
import ComplexPolymerComponentsTabState from './ComplexPolymerComponentsTabState';

export default class ComplexPolymerComponentsTabView extends BufferTabView<ComplexPolymerComponentsTabState> {
  render(): this {
    const props = {
      complexPolymerId: this.model.get('complexPolymerId'),
      isEditable: this.model.get('isEditable'),
    };
    renderToDOM(<ComplexPolymerComponentsTableTab {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<ComplexPolymerComponentsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ComplexPolymerComponentsTabView.prototype.className = 'buffer-tab';
